import { render, staticRenderFns } from "./PeopleWidget.vue?vue&type=template&id=39334a8d&scoped=true"
import script from "./PeopleWidget.vue?vue&type=script&lang=js"
export * from "./PeopleWidget.vue?vue&type=script&lang=js"
import style0 from "./PeopleWidget.vue?vue&type=style&index=0&id=39334a8d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39334a8d",
  null
  
)

export default component.exports